export const localeText = {
    selectAll: 'Seleccionar todo',
    selectAllSearchResults: 'Seleccionar todos los resultados de la búsqueda',
    searchOoo: 'Buscar...',
    blanks: 'Vacio',
    noMatches: 'No hay coincidencias',
    filterOoo: 'Filtro...',
    equals: 'Igual a',
    notEqual: 'No es igual a',
    lessThan: 'Menor que',
    greaterThan: 'Mayor que',
    lessThanOrEqual: 'Menor o igual',
    greaterThanOrEqual: 'Mayor o igual',
    inRange: 'En rango',
    inRangeStart: 'Desde',
    inRangeEnd: 'Hasta',
    contains: 'Contiene',
    notContains: 'No contiene',
    startsWith: 'Comienza con',
    endsWith: 'Termina con',
    dateFormatOoo: 'dd-mm-Yyyy',
    andCondition: 'Y',
    orCondition: 'O',
    applyFilter: 'Aplicar',
    resetFilter: 'Reiniciar',
    clearFilter: 'Limpiar',
    cancelFilter: 'Cancelar',
    columns: 'Columnas',
    filters: 'Filtros',
    pivotMode: 'Modo pivot',
    groups: 'Grupos de filtros',
    rowGroupColumnsEmptyMessage: 'Arrastra hasta acá para establecer grupos de filas',
    values: 'Valores',
    valueColumnsEmptyMessage: 'Arrastra hasta acá para agregar',
    pivots: 'Nombres columnas',
    pivotColumnsEmptyMessage: 'Arrastra hasta acá para establecer los nombres de las columnas',
    group: 'Grupo',
    loadingOoo: 'Cargando...',
    noRowsToShow: 'No hay filas para mostrar',
    enabled: 'Activado',
    pinColumn: 'Fijar Columna',
    pinLeft: 'Fijar a la izquierda',
    pinRight: 'Fijar a la derecha',
    noPin: 'No fijar',
    valueAggregation: 'Agregar valor',
    autosizeThiscolumn: 'Autoajustar esta columna',
    autosizeAllColumns: 'Autoajustar todas las columnas',
    groupBy: 'Agrupar por',
    ungroupBy: 'Un-Group by',
    resetColumns: 'Reiniciar columnas',
    expandAll: 'Expandir',
    collapseAll: 'Cerrar',
    copy: 'Copiar',
    ctrlC: 'Ctrl+C',
    copyWithHeaders: 'Copiar con los encabezados',
    paste: 'Pegar',
    ctrlV: 'Ctrl+V',
    export: 'Exportar',
    csvExport: 'Exportar a CSV',
    excelExport: 'Exportar a Excel (.xlsx)',
    excelXmlExport: 'Exportar a Excel (.xml)',
    sum: 'Suma',
    min: 'Mínimo',
    max: 'Máximo',
    none: 'Nada',
    count: 'Contar',
    avg: 'Promedio',
    filteredRows: 'Filtrado',
    selectedRows: 'Seleccionador',
    totalRows: 'Filas totales',
    totalAndFilteredRows: 'Filas',
    page: 'Página',
    more: 'Más',
    to: 'hasta',
    of: 'de',
    next: 'Siguiente',
    last: 'Última',
    first: 'Primera',
    previous: 'Anterior',
    pivotChartAndPivotMode: 'Pivot Chart & Pivot Mode',
    pivotChart: 'Pivot Chart',
    chartRange: 'Chart Range',
    columnChart: 'Columna',
    groupedColumn: 'Agrupados',
    stackedColumn: 'Acumulados',
    normalizedColumn: '100% Acumulados',
    barChart: 'Bar',
    groupedBar: 'Agrupados',
    stackedBar: 'Acumulados',
    normalizedBar: '100% Acumulados',
    pieChart: 'Pie',
    pie: 'Pie',
    doughnut: 'Dona',
    line: 'Linea',
    xyChart: 'X Y (Scatter)',
    scatter: 'Scatter',
    bubble: 'Burbuja',
    areaChart: 'Área',
    area: 'Área',
    stackedArea: 'Acumulados',
    normalizedArea: '100% Acumulados',
    histogramChart: 'Histograma',
    pivotChartTitle: 'Pivot Chart',
    rangeChartTitle: 'Range Chart',
    settings: 'Ajustes',
    data: 'Data',
    format: 'Format',
    categories: 'Categorías',
    defaultCategory: '(Nada)',
    series: 'Series',
    xyValues: 'X Y Values',
    paired: 'Paired Mode',
    axis: 'Eje',
    color: 'Color',
    thickness: 'Thickness',
    xType: 'X Type',
    automatic: 'Automático',
    category: 'Categoría',
    number: 'Número',
    time: 'Hora',
    xRotation: 'X Rotation',
    yRotation: 'Y Rotation',
    ticks: 'Ticks',
    width: 'Ancho',
    height: 'Alto',
    length: 'Length',
    padding: 'Padding',
    chart: 'Chart',
    title: 'Título',
    background: 'Fondo',
    font: 'Fuente',
    top: 'Top',
    right: 'Right',
    bottom: 'Bottom',
    left: 'Left',
    labels: 'Etiquetas',
    size: 'Tamaños',
    minSize: 'Tamaño mínimo',
    maxSize: 'Tamaño máximo',
    legend: 'Leyenda',
    position: 'Posición',
    markerSize: 'Marker Size',
    markerStroke: 'Marker Stroke',
    markerPadding: 'Marker Padding',
    itemPaddingX: 'Item Padding X',
    itemPaddingY: 'Item Padding Y',
    strokeWidth: 'Stroke Width',
    offset: 'Offset',
    offsets: 'Offsets',
    tooltips: 'Tooltips',
    callout: 'Callout',
    markers: 'Markers',
    shadow: 'Shadow',
    blur: 'Blur',
    xOffset: 'X Offset',
    yOffset: 'Y Offset',
    lineWidth: 'Line Width',
    normal: 'Normal',
    bold: 'Bold',
    italic: 'Italic',
    boldItalic: 'Bold Italic',
    predefined: 'Predefined',
    fillOpacity: 'Fill Opacity',
    strokeOpacity: 'Line Opacity',
    histogramBinCount: 'Bin Count',
    columnGroup: 'Column',
    barGroup: 'Bar',
    pieGroup: 'Pie',
    lineGroup: 'Line',
    scatterGroup: 'Scatter',
    areaGroup: 'Area',
    histogramGroup: 'Histogram',
    groupedColumnTooltip: 'Grouped',
    stackedColumnTooltip: 'Stacked',
    normalizedColumnTooltip: '100% Stacked',
    groupedBarTooltip: 'Grouped',
    stackedBarTooltip: 'Stacked',
    normalizedBarTooltip: '100% Stacked',
    pieTooltip: 'Pie',
    doughnutTooltip: 'Doughnut',
    lineTooltip: 'Line',
    groupedAreaTooltip: 'Grouped',
    stackedAreaTooltip: 'Stacked',
    normalizedAreaTooltip: '100% Stacked',
    scatterTooltip: 'Scatter',
    bubbleTooltip: 'Bubble',
    histogramTooltip: 'Histograma',
    noDataToChart: 'No data available to be charted.',
    pivotChartRequiresPivotMode: 'Pivot Chart requires Pivot Mode enabled.',
    navigator: 'Navigator',
}